// src/types/shared/UseAlert.tsx
import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert, { AlertProps } from '@mui/material/Alert';

interface UseAlertProps {
  open: boolean;
  message: string;
  status: number;
  onClose: () => void;
}

const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const UseAlert1: React.FC<UseAlertProps> = ({ open, message, status, onClose }) => {
  const getSeverity = (status: number) => {
    if (status === 200) return 'success';
    if (status >= 400 && status < 500) return 'warning';
    if (status >= 500) return 'error';
    return 'info';
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert onClose={onClose} severity={getSeverity(status)} sx={{ width: '100%' }}>
        {message}
      </Alert>
    </Snackbar>
  );
};


export default UseAlert1;

